<template>
  <alert-modal
    name="critical-error"
    :alert="$t('SERVER_ERROR_RELOAD_CTA')"
    :title="$t('SERVER_ERROR_HEADER')"
    @dismiss="onDismiss"
  >
    {{ $t('SERVER_ERROR_SUPPORTING') }}
  </alert-modal>
</template>

<script>
import AlertModal from '~/components/alert-modal'
import UIMixin from '~/mixins/ui'

export default {
  mixins: [UIMixin],
  components: {
    AlertModal
  },
  methods: {
    onDismiss () {
      this.$ui.modal.close('critical-error')
      this.$router.go()
    }
  }
}
</script>

<style lang="scss">

div.alert-modal {
  .modal {
    .modal-inner {
      h2 {
        @include title-lrg;
      }

      button {
        width: 100%;
        margin-top: $d-med;
      }
    }
  }
}
</style>